//AI评阅上传
import FileUpload from '@/pages/pageComponents/AgentUpload/Upload/ReviewFileUpload';
import { agentFileBucketName } from '@/utils/Page/constant';
import { Tooltip } from 'antd';
import { PaperClipOutlined } from '@ant-design/icons';
import { UploadType } from '@/components/Upload';
import s from '../style.module.scss';

const title = (
    <div style={{ textAlign: 'center' }}>
        <div>上传文件（最多1个，单个文件最大500Mb）</div>
        <div>支持pdf、doc、docx、zip格式</div>
    </div>
);
const EvalutionUpload = (props) => {
    const UploadConfig = {
        sizeTip: '只支持500Mb以内的文件',
        typeTip: '不支持上传此文件类型',
        maxSize: 500 * 1024 * 1024,
        ossBucketName: agentFileBucketName.oss,
        uploadType: UploadType.AGENT
    };
    const { setAgentFile, agentFile } = props;
    return (
        <FileUpload UploadConfig={UploadConfig} agentFile={agentFile} disabled={agentFile.length > 0} setAgentFile={setAgentFile}>
            <div style={{ height: 32 }} data-disabled={agentFile.length > 0} data-type="file" className={`${s['plugin-item']}`}>
                <Tooltip rootClassName="plugin-tooltip" title={title}>
                    <PaperClipOutlined />
                </Tooltip>
            </div>
        </FileUpload>
    );
};
export default EvalutionUpload;
